/* eslint-disable */
export default {
  to: 'Vst.ot:',
  enterNameOrPhoneNumber: 'Anna numero',
} as const;

// @key: @#@"to"@#@ @source: @#@"To:"@#@
// @key: @#@"enterNameOrPhoneNumber"@#@ @source: @#@"Enter Number"@#@
